import * as React from 'react';
export const linepaySvg = React.forwardRef(function linepaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M26.582 28H5.814A.815.815 0 0 1 5 27.186v-12.42a.815.815 0 0 1 .814-.815h20.768a.815.815 0 0 1 .815.815v12.42a.815.815 0 0 1-.815.814Z',
      fill: '#08BF5B',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20.868 19.059a.19.19 0 0 1 .108.032.193.193 0 0 1 .07.087l1.104 2.692 1.069-2.69a.192.192 0 0 1 .178-.121h1.185c.081 0 .137.082.107.157l-2.47 6.223a.194.194 0 0 1-.178.12h-1.186a.116.116 0 0 1-.106-.158l.672-1.69-1.844-4.494a.115.115 0 0 1 .107-.158h1.184Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M15.813 18.929c.622 0 1.077.214 1.383.566v-.321c0-.064.052-.115.115-.115h1.162c.063 0 .115.051.115.115v4.41a.115.115 0 0 1-.115.114H17.31a.115.115 0 0 1-.115-.115v-.32c-.306.352-.761.565-1.383.565-1.215 0-2.217-1.066-2.217-2.449 0-1.383 1.002-2.45 2.217-2.45Zm.279 1.317c-.64 0-1.105.437-1.105 1.133s.465 1.132 1.105 1.132c.64 0 1.104-.436 1.104-1.132s-.464-1.133-1.104-1.133ZM10.8 17.202c1.281 0 2.274.994 2.274 2.228 0 1.234-.993 2.226-2.273 2.226h-.975v1.824c0 .12-.097.218-.218.218H8.561a.219.219 0 0 1-.22-.218v-6.06a.22.22 0 0 1 .22-.219h2.24Zm-.974 3.063h.975c.454 0 .789-.362.789-.835 0-.474-.335-.835-.79-.835h-.974v1.67Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.128 4.001a.31.31 0 0 1 .31.31v5.515h3.006a.31.31 0 0 1 .31.31v1.116a.31.31 0 0 1-.31.31H6.012a.31.31 0 0 1-.31-.31V4.311a.31.31 0 0 1 .31-.31h1.116Zm5.854 0a.31.31 0 0 1 .31.31v6.941a.31.31 0 0 1-.31.31h-1.116a.31.31 0 0 1-.31-.31V4.311a.31.31 0 0 1 .31-.31h1.116Zm2.862 0c.137 0 .26.034.343.152l2.92 4.174V4.311a.31.31 0 0 1 .31-.31h1.115a.312.312 0 0 1 .31.31v6.941a.31.31 0 0 1-.31.31h-1.137a.312.312 0 0 1-.215-.11.36.36 0 0 1-.035-.043l-3.044-4.351v4.194a.312.312 0 0 1-.31.31h-1.116a.31.31 0 0 1-.31-.31V4.311a.31.31 0 0 1 .31-.31h1.17Zm10.756 0a.311.311 0 0 1 .31.31v1.116a.31.31 0 0 1-.31.31h-3.007v1.177H26.6a.311.311 0 0 1 .31.31V8.34a.311.311 0 0 1-.31.31h-3.006v1.177H26.6a.311.311 0 0 1 .31.31v1.115a.312.312 0 0 1-.31.31h-4.43a.31.31 0 0 1-.31-.31v-6.94a.31.31 0 0 1 .31-.311h4.43Z',
      fill: '#000',
    }),
  );
});
linepaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var linepay = {
  category: 'brand',
  colorable: false,
  name: 'linepay',
  svg: linepaySvg,
};
